module.exports = __webpack_public_path__ + "static/media/backarrow_darkbleu.a82069f8.svg";